export interface LegacyColorSettingItem {
  id: string
  officeId: string
  memo: string
  color: string
  hidden: boolean
}

export const legacyColorOffices = Array.from({ length: 26 }, (_, index) => ({
  id: String(index + 1),
  name: `모의지점 ${String(index + 1).padStart(2, '0')}`,
}))

const mockColors = [
  '#2c9100', '#ff6b6b', '#ff9f43', '#feca57', '#1dd1a1', '#10ac84',
  '#48dbfb', '#0abde3', '#54a0ff', '#2e86de', '#5f27cd', '#8e44ad',
  '#ff9ff3', '#f368e0', '#576574', '#8395a7', '#222f3e', '#c8d6e5',
]

export const legacyColorSettings: LegacyColorSettingItem[] = mockColors.map((color, index) => ({
  id: `mock-color-${index + 1}`,
  officeId: '1',
  memo: `Mock 색상 ${String(index + 1).padStart(2, '0')}`,
  color,
  hidden: false,
}))
